import React from "react";
import { FormattedMessage } from "react-intl";

import "./WizardSidebar.scss";

export const WizardSidebar = () => (
  <div className="wizard-sidebar">
    <div className="wizard-sidebar__title">
      <FormattedMessage id="single_profile" />
    </div>
    <p className="wizard-sidebar__description">
      <FormattedMessage id="same_level_of_protection" />
    </p>
  </div>
);
